import { BaseModal, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import React, { useState } from 'react';
import { ReactComponent as ErrorIcon } from 'assets/icons/error.svg';
import { apiService } from 'utils/api';
import { toast } from 'react-toastify';
type Props = {
  show: boolean;
  onClose: () => void;
  title: string;
  id: string;
};

type DeleteModalFooterProps = {
  onClose: () => void;
  loading: boolean;
  onConfirm: () => void;
};

const DeleteModalFooter = ({ onClose, loading, onConfirm }: DeleteModalFooterProps) => {
  return (
    <div className='w-full flex items-center justify-between mt-4 gap-8'>
      <Button
        onClick={onClose}
        className='border border-gray-5 text-gray-5 hover:bg-gray-5 hover:text-white'
        small
        variant='block'
        color='gray'>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        className='bg-red-5 hover:bg-red-6 text-white'
        small
        variant='block'
        color='primary'
        loading={loading}>
        Delete
      </Button>
    </div>
  );
};
const DeleteNoticeModal = ({ show, onClose, title, id }: Props) => {
  const [loading, setLoading] = useState(false);

  const deleteNotice = async () => {
    setLoading(true);
    try {
      apiService.post(`kitchen/team-notification/delete/${id}`, {
        baseUrl: 'https://order-api.getfoodcourt.com/v1/'
      });
      toast(<ToastMessage type='success' message='Notice deleted successfully' />);
    } catch (error) {
      toast(<ToastMessage type='error' message='Error deleting notice' />);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <BaseModal
      bodyOpenClassName={'hide_title_icon'}
      isOpen={show}
      onRequestClose={onClose}
      title=''
      titleIcon={<ErrorIcon />}
      titleIconColor='danger'
      footer={
        <DeleteModalFooter
          onClose={onClose}
          loading={loading}
          onConfirm={() => {
            deleteNotice();
          }}
        />
      }>
      <div className='flex flex-col justify-center items-center'>
        <ErrorIcon className='mx-auto mb-4' />
        <p className='font-medium text-[18px]'>Delete Notice</p>
        <p className='text-sm text-gray-8 text-center'>
          Are you sure you want to delete {title} announcement
        </p>
      </div>
    </BaseModal>
  );
};

export default DeleteNoticeModal;
